



























import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SubscriptionTable from '@subscriptions/components/tables/subscription-table/subscription-table.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import BpcDirectDebitFilesTabs from '@accounting/components/tabs/direct-debit-files/direct-debit-files-tabs.vue';

@Component({
  name: 'bpc-subscriptions-direct-debits-follow-up',
  components: {
    'bpc-subscription-table': SubscriptionTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-direct-debit-files-tabs': BpcDirectDebitFilesTabs,
  },
})
export default class SubscriptionDirectDebits extends Vue {
  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }
}
